import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import React from 'react';
import './style.scss';
import MenuItem from '@material-ui/core/MenuItem';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography
} from '@material-ui/core';

const currencies = [
  {
    value: 'ContenNFT',
    label: 'nftencer',
  },
  {
    value: 'Vip',
    label: 'Vip service',
  },
];
const Login = () => {
  const navigate = useNavigate();
  const [currency, setCurrency] = React.useState('ContenNFT');
  const handleChangeDomain = (event) => {
    setCurrency(event.target.value);
  };
  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container className="container" maxWidth="sm">
          <Formik
            initialValues={{
              email: 'admin@nftencer.com',
              // password: 'admin'
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
              password: Yup.string().matches('admin', 'Password does not meet requirements.').max(255).required('Password is required'),
              // select: Yup.string().matches('admin', 'Password does not meet requirements.').required('Password is required')
            })}
            onSubmit={() => {
              navigate('/app/customers', { replace: true });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 3 }}>
                    {/* <img className="logo-admin" alt="logo" src="" /> */}
                    {/* <img className="logo-admin" alt="logo" src="/static/icon-ccn_logo.svg" /> */}
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <div className="domain_container">
                      <Typography
                        color="textPrimary"
                        variant="h2"
                      >
                        Log in
                      </Typography>
                      <TextField
                        error={Boolean(currency !== 'ContenNFT')}
                        // helperText={currency !== 'ContenNFT'}
                        id="standard-select-currency"
                        className="option_domain"
                        select
                        label="select"
                        name="select"
                        type="select"
                        value={currency}
                        onChange={handleChangeDomain}
                        // helperText="Please select domain"
                      >
                        {currencies.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>
                  </Box>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    label="Email Address"
                    margin="normal"
                    name="email"
                    defaultValue=""
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="email"
                    value={values.email}
                    variant="outlined"
                  />
                  <TextField
                    error={Boolean(touched.password && errors.password)}
                    fullWidth
                    helperText={touched.password && errors.password}
                    label="Password"
                    margin="normal"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="password"
                    value={values.password}
                    variant="outlined"
                  />
                  <Box sx={{ py: 2 }}>
                    { currency === 'ContenNFT'
                      ? (
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          fullWidth
                          size="large"
                          type="submit"
                          variant="contained"
                        >
                          Sign in now
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          fullWidth
                          size="large"
                          type="button"
                          variant="contained"
                        >
                          Sign in now
                        </Button>
                      )}
                  </Box>
                </form>
              );
            }}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default Login;
